// extracted by mini-css-extract-plugin
module.exports = {"notificationsContainer":"NotificationAfholder_notificationsContainer__Em_YX","notification":"NotificationAfholder_notification__j7ONH"};